import Link from 'next/link';

import { SUPPORT_TG_URL } from '@/app/config/const';
import { CareerOfferTrackedLink } from '@/features/career-offer-analytics';
import { userAgreementDocument } from '@/shared/constants';
import { cn } from '@/shared/utils';

import { Container } from './container';

export const Footer = ({
	className,
	showCareerOfferLink = false,
}: {
	className?: string;
	showCareerOfferLink?: boolean;
}) => {
	return (
		<footer
			className={cn(
				'bg-gray-9 mt-20 py-7 text-xs/[1.2] lg:text-sm 2xl:mt-10',
				className,
			)}
		>
			<Container className="text-gray-6">
				<div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
					<div className="flex flex-col gap-2">
						<div>ООО «Отус Онлайн-Образование»</div>
						<div className="flex flex-col gap-1">
							<span>ОГРН 1177746618576</span>
							<span>ИНН 9705100963</span>
							<Link
								href={SUPPORT_TG_URL}
								className="hover:underline"
								target="_blank"
								rel="noopener noreferrer"
							>
								Поддержка
							</Link>
						</div>
					</div>
					<div className="flex flex-col gap-3 max-lg:text-[10px]/[1.2]">
						<Link
							className="text-inherit hover:underline"
							href="https://otus.ru/legal/common/"
							target="_blank"
							rel="noopener noreferrer"
						>
							Сведения об образовательной организации
						</Link>
						<Link
							className="text-inherit hover:underline"
							href="https://otus.ru/legal/it_company_accreditation/"
							target="_blank"
							rel="noopener noreferrer"
						>
							OTUS является аккредитованной IT-компанией
						</Link>
						<Link
							className="text-inherit hover:underline"
							href="https://reestr.digital.gov.ru/reestr/2704482/"
							target="_blank"
							rel="noopener noreferrer"
						>
							В реестре отечественного ПО №24216
						</Link>
						<Link
							className="text-inherit hover:underline"
							href={userAgreementDocument.url}
							target="_blank"
						>
							Условия использования сервиса
						</Link>
						<Link
							className="text-inherit hover:underline"
							href="https://otus.ru/legal/recommendations/"
							target="_blank"
							rel="noopener noreferrer"
						>
							Сведения о рекомендательных технологиях
						</Link>
					</div>
					{showCareerOfferLink && (
						<div className="flex flex-col gap-3">
							<CareerOfferTrackedLink
								placement="community_footer"
								entrypoint="promo"
								className="text-inherit hover:underline"
							>
								Программа до оффера
							</CareerOfferTrackedLink>
						</div>
					)}
				</div>
			</Container>
		</footer>
	);
};
